@if (request(); as dialog) {
  <div class="confirm-dialog-overlay">
    <div class="confirm-dialog" role="dialog" aria-modal="true">
      <div class="confirm-dialog__content">
        <h2>{{ dialog.title }}</h2>
        <p>{{ dialog.message }}</p>
      </div>
      <div class="dialog-actions">
        <button [class.confirm-button-error]="dialog.danger" [class.confirm-button-success]="!dialog.danger" type="button" (click)="resolve(true)">{{ dialog.confirmLabel }}</button>
        <button class="cancel-button" type="button" (click)="resolve(false)">Отменить</button>
      </div>
    </div>
  </div>
}
